// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dashboard Cards */

.templates-grid {
  display: inline-block;
  display: flex;
  flex-flow: wrap;
  flex-grow: 50px;
  gap: 3.5%;
}
.template-col{
 display: inline-block;
 float: left;
 width: 31%;
 text-align: center;
}
/*
.categories-area {
  width: 25%;
}

.category-item a {
  font-size: 1.3em;
  color: #919191;
  font-weight: 400;
  padding-bottom: 0.6em;
  transition: all .15s ease-in-out;
}

.category-item a:hover {
  color: #919191;
  font-weight: 500;
  padding-left: 3px;
}

.category-item a.active {
  color: #007bff;
  font-weight: 600;
  padding-left: 7px;
} */


.templates-category-swiper .swiper-slide {
  cursor: pointer;
}
.templates-category-swiper .swiper-slide:not(.swiper-slide-active) {
  opacity: 1 !important;
}
.badge-salesfunnel {
  background: #E89E3A;
  color: #fff;
}

.badge-optin {
  background: #D540BF;
  color: #fff;
}

.badge-webinar {
  background: #2ebef7;
  color: #fff;
}

.type-badge {
  min-width: 70px;
    font-size: 16px;
  font-family: Helvetica, Arial, sans-serif;
}

 @media screen and (max-width: 900px) {
  .newtemplate-col,.template-col{width: 100%;}
  .cards {
    padding: 0;
  }

}

@media screen and (min-width:900px) and (max-width: 1024px) {
  .newtemplate-col,.template-col{width: 46%;}

}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/shared/wizard/templates-layout/templates-layout.component.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;EACE,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,eAAe;EACf,SAAS;AACX;AACA;CACC,qBAAqB;CACrB,WAAW;CACX,UAAU;CACV,kBAAkB;AACnB;AACA;;;;;;;;;;;;;;;;;;;;;;;GAuBG;;;AAGH;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;IACb,eAAe;EACjB,yCAAyC;AAC3C;;CAEC;EACC,+BAA+B,WAAW,CAAC;EAC3C;IACE,UAAU;EACZ;;AAEF;;AAEA;EACE,+BAA+B,UAAU,CAAC;;AAE5C;;AAEA,gkFAAgkF","sourcesContent":["/* Dashboard Cards */\n\n.templates-grid {\n  display: inline-block;\n  display: flex;\n  flex-flow: wrap;\n  flex-grow: 50px;\n  gap: 3.5%;\n}\n.template-col{\n display: inline-block;\n float: left;\n width: 31%;\n text-align: center;\n}\n/*\n.categories-area {\n  width: 25%;\n}\n\n.category-item a {\n  font-size: 1.3em;\n  color: #919191;\n  font-weight: 400;\n  padding-bottom: 0.6em;\n  transition: all .15s ease-in-out;\n}\n\n.category-item a:hover {\n  color: #919191;\n  font-weight: 500;\n  padding-left: 3px;\n}\n\n.category-item a.active {\n  color: #007bff;\n  font-weight: 600;\n  padding-left: 7px;\n} */\n\n\n.templates-category-swiper .swiper-slide {\n  cursor: pointer;\n}\n.templates-category-swiper .swiper-slide:not(.swiper-slide-active) {\n  opacity: 1 !important;\n}\n.badge-salesfunnel {\n  background: #E89E3A;\n  color: #fff;\n}\n\n.badge-optin {\n  background: #D540BF;\n  color: #fff;\n}\n\n.badge-webinar {\n  background: #2ebef7;\n  color: #fff;\n}\n\n.type-badge {\n  min-width: 70px;\n    font-size: 16px;\n  font-family: Helvetica, Arial, sans-serif;\n}\n\n @media screen and (max-width: 900px) {\n  .newtemplate-col,.template-col{width: 100%;}\n  .cards {\n    padding: 0;\n  }\n\n}\n\n@media screen and (min-width:900px) and (max-width: 1024px) {\n  .newtemplate-col,.template-col{width: 46%;}\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
